import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { useBillOfMaterialsContext } from './Context'
import { BomEmptyContent } from './BomEmptyContent'
import { TabularTree } from '@ztechapps/webui.data-tools'
import type { ProductBillOfMaterial } from '@ztechapps/common.contract'
import { BomHead } from './BomHead'
import { BomRow } from './BomRow'
import { NewRow } from './NewRow'
import { useToggle } from 'react-use'
import { ShowIf } from '@ztechapps/webui.util'

export const BomDetails = () => {
  const { product, canEdit } = useBillOfMaterialsContext()
  const bom = product?.billOfMaterials
  const parentProductId = product?._id

  const topLevelAddToggle = useToggle(false)
  const [showTopLevelAdd] = topLevelAddToggle

  const rootBom = {
    product,
  } as ProductBillOfMaterial

  if (isEmpty(bom)) {
    return <BomEmptyContent parentProductId={parentProductId} billOfMaterials={bom} />
  }

  return (
    <TabularTree<ProductBillOfMaterial>
      root={rootBom}
      head={<BomHead topLevelAddToggle={topLevelAddToggle} />}
      row={BomRow}
      childrenKey="product.billOfMaterials"
      newRow={canEdit ? NewRow : undefined}
      foot={
        <ShowIf condition={showTopLevelAdd}>
          <tfoot>
            <NewRow
              root={undefined}
              parent={undefined}
              item={rootBom}
              index={0}
              level={0}
              items={bom}
              toggleShowChildren={undefined}
              toggleShowNew={undefined}
              leftMarginStyle={undefined}
            />
          </tfoot>
        </ShowIf>
      }
    />
  )
}
